import { createContext } from "react";
import Statistics from "./admin_components/Statistics";

export const defaultTextValues = {
  activeLang: 'it-IT',
  defaultLang: 'it-IT',
  texts: {
    'it-IT': {
      sidebar: {
        settings: {
          title: 'Impostazioni utente',
          profile: {
            title: 'Profilo',
            language_select: 'Seleziona lingua',
            language_name: 'Italiano',
            g_account: 'Account Google:',
            g_connect: 'Connesso',
            g_disconnect: 'Disconnetti',
            g_notconnect: 'Non connesso',
            g_login: 'Accedi',
            user_username: 'Username',
            user_username_taken: 'Username già in uso',
            user_password: 'Password',
            cal_hours_title: 'Visualizzazione calendario',
            cal_hours_start: 'Dalle',
            cal_hours_end: 'Alle',
            download: 'Scarica prezzario'
          },
          shop: {
            title: "Sede",
            sub_title1: 'Impostazioni sede:',
            shop_select: 'Seleziona sede:',
            shop_name: 'Nome sede:',
            shop_sms_name: "Nome su sms:",
            language_select: 'Seleziona lingua',
            mailer_select: 'Indirizzo di invio mail',
            sub_title2: 'Impostazioni messaggio',
            message_instructions_text: 'Attenzione nel messaggio è obbligatorio inserire le seguenti variabili:',
            message_instructions_li1: '%name% - nome del cliente',
            message_instructions_li2: '%surname% - cognome del cliente',
            message_instructions_li3: '%time% - orario dell\'appuntamento',
            message_label: 'Messaggio',
            message_example: 'Esempio',
            message_hours: 'inserire quante ore prima si vuol inviare il promemoria',
            message_hours_unit: 'Ore',
            psw_change: 'Password cambiata con successo',
            psw_bleh: 'Password troppo debole',
            error: 'Errore generico, riprova più tardi',
            change_ok: 'Modifica effettuata con successo',
            sub_title3: 'Modifica utenti:',
            user_select: 'Seleziona utente:',
            group_select: 'Gruppo di permessi:',
            user_username: 'Username',
            user_password: 'Password',
            day_appo: '%day% - giorno dell appuntamento',
            mex_client: 'Messaggio al cliente',
            fuso:'Fuso orario:',
            pref:'Prefisso predefinito:',
            p_auto:'Abilita prenotazioni automatiche',
            fuso:'Fuso orario:',
            prepre:'Prefisso predefinito:',
            auto_preno:'Abilita prenotazioni automatiche',
            t_user:'Utenti',
            active_def:'Sms attivi inizialmente per tutti i clienti',
            active_def2:'Email attivi inizialmente per tutti i clienti',
            
            hour: {
              title: 'Orari di apertura:',
              lunedi: 'Lunedì',
              martedi: 'Martedì',
              mercoledi: 'Mercoledì',
              giovedi: 'Giovedì',
              venerdi: 'Venerdì',
              sabato: 'Sabato',
              domenica: 'Domenica',
              open: 'Inizio:',
              close: 'Fine:',
              close_day: 'Chiuso'
            },
          },
          groups: {
            title: 'Gruppi',
            manage_group: 'Gestisci gruppi',
            add_button: 'Nuovo gruppo',
            edit_button: 'Modifica gruppo',
            group_select: 'Seleziona gruppo:',
            group_name: 'Nome gruppo',
            group_priority: 'Priorità gruppo',
            is_admin: 'Admin',
            view_shops: 'Visualizza sedi',
            change_username: 'Cambia username',
            us_min: 'Lunghezza minima del nome: 3 caratteri',
            us_max: 'Nome troppo lungo',
            change_password: 'Cambia password',
            change_pic: 'Cambia immagine',
            change_hours: 'Cambia ore',
            change_theme: 'Cambia tema',
            add_theme: 'aggiungi tema',
            add: 'Aggiungi',
            edit: 'Modifica',
            delete: 'Elimina',
            g_delete: 'Questo gruppo è collegato a degli utenti, scollegarlo prima dell\'eliminazione',
            event: 'evento',
            apt: 'appuntamento',
            category: 'categoria',
            customer: 'cliente',
            user: 'utente',
            shop: 'sede',
            admin_help: 'Permette di possedere tutti i permessi',
            manage_group_help: 'Permette di aggiungeree modificare i gruppi',
            show_shops_help: 'Permette di visualizzare sedi diverse dalla propria',
            change_username_help: 'Permette di cambiare il proprio username',
            change_password_help: 'Permette di modificare la password del proprio account',
            change_pic_help: 'Permette di modificare l\'immagine del proprio account',
            change_hours_help: 'Permette di modificare la visualizzazione oraria del calendario'
          },
          theme: {
            title: 'Tema',
            theme_select: 'Seleziona tema'
          },
          save_modal: {
            title: 'Attenzione',
            body: 'Attenzione, i dati non salvati saranno eliminati',
            cancel: 'Annulla',
            not_save: 'Non salvare',
            save: 'Salva'
          },
          del_modal: {
            title: 'Attenzione',
            body: 'Una volta eliminato il gruppo non sarà recuperabile',
            cancel: 'Annulla',
            delete: 'Elimina'
          },
          add_theme: {
            title: 'Nuovo tema',
            theme_name: 'Nome',
            text_font: 'Font testi',
            title_font: 'Font titoli',
            font_dimension: 'Dimensione testi',
            sub_title1: 'Colori:',
            color1: 'Sfondo calendario:',
            color2: 'Sfondo generale',
            color3: 'Sfondo sidebar',
            color4: 'Testo scuro',
            color5: 'Testo chiaro',
            color6: 'Oggetti evidenziati',
            shadows: 'Ombre',
            shadow_opacity: 'Opacità'
          }
        }
      },
      leftbar: {
        customer_service: {
          title: 'Assistenza clienti',
          body1: 'Se non sai come effettuare un\'operazione clicca sul pulsante verde per leggere il manuale,',
          body2: 'se non riesci a risolvere il problema puoi chiederci assistenza cliccando uno dei bottoni qui sotto oppure:',
          li1: 'Chiamandoci al ',
          a1: '+41 76 579 4367',
          li2: 'Scrivendoci a ',
          a2: 'assistenza@nacweb.ch',
        },
        notify: {
          title: 'Ultime notifiche',
          none: 'Nessuna Notifica'
        },
        exit: {
          title: 'Attenzione',
          log: 'Sicuro di voler effettuare il logout?',
          back: 'Annulla',
          continue: 'Conferma'
        }

      },
      calendar: {
        locale: 'it-IT',
        today: 'Oggi',
        view_select: {
          day: 'giorno',
          week: 'settimana',
          month: 'mese'
        },
        category: {
          title: 'Categorie',
          add_category: {
            title: 'Aggiungi',
            category_name: 'Nome',
            cateogry_time: 'Durata',
            is_apt: 'È una categoria di appuntamenti?',
            color: 'Colore:',
            title_placeholder: 'tinta',
            prev: 'Previeni appuntamenti?',
            description: 'Il periodo di durata di questo evento sarà considerato come orario di chiusura, in questo modo non sarà possibile creare appuntamenti da prenotazioni online e/o utenti senza permesso',
            prev_pren:'Utilizzabile nelle prenotazioni',
            previeni:'Previeni prenotazione automatica',
            permetti:'Permetti prenotazione automatica',
            prev_pren_help: 'Se attivo permette ai clienti di chiedere un appuntamento per questa categoria',
            cont:'Previeni appuntamenti in contemporanea?',
            cont_desc:'Se attivo non sarà possibile, tramite prenotazione automatica da parte del cliente, richiedere un apputamento di questo tipo quando nè esiste già uno.',
            glo:'Visibile a tutti gli utenti?',
            glo2:'se attivo rende gli eventi di questa categoria visibili a tutti gli utenti della sede'

          
          },
          edit_category: {
            title: 'Modifica',
            previeni:'Previeni prenotazione automatica',
            time: 'Durata:',
            select_category: 'Seleziona categoria da modificare',
            category_name: 'Nome',
            is_apt: 'È una categoria di appuntamenti?',
            color: 'Colore:',
            title_placeholder: 'tinta',
            prev_pren:'Utilizzabile nelle prenotazioni',
          },
          delete_category: {
            title: 'Elimina',
            select_category: 'Seleziona categoria da eliminare:',
            text_delete: 'Attenzione! L\'eliminazione non è reversibile, eliminando la categoria verrà assegnato il colore di default a tutti gli eventi associati ad esso.'
          }
        },
        warning: {
          title: 'Attenzione, orario di chiusura',
          closed: 'Questo è segnato come un orario di chiusura, si è sicuri di voler aggiungere un appuntamento qui?'

        },
        notify: {
          add_client: 'Cliente aggiunto con successo',
          error_client: 'Errore durante l\'aggiunta del cliente',
          modify_client: 'Cliente modificato con successo',
          success_modify: 'Evento modificato con successo',
          error_event: 'Errore nella modifica dell\'evento',
          error_modify: 'Errore nella modifica del cliente',
          delete_client: 'Cliente eliminato con successo',
          delete_error: 'Errore nell\'eliminazione del cliente',
          google_disconnect: 'Google disconnesso con successo',
          error_disconnect: 'Errore nella disconnessione da google',
          success_password: 'Password modificata con successo',
          skillissue_psw: 'Password troppo debole',
          error_psw: 'Errore nella modifica della password',
          modify_utent: 'Utente modificato con successo',
          used_username: 'Username già in uso',
          error_modify_utent: 'Errore nella modifica dell\'utente',
          success_delete: 'Evento eliminato con successo',
          error_delete: 'Errore durante l\'eliminazione dell\'evento',
          add_category: 'Categoria aggiunta con successo',
          error_category: 'Errore durante l\'aggiunta della categoria',
          add_group: 'Gruppo aggiunto con successo',
          error_group: 'Errore nell\'aggiunta del gruppo',
          group_modify: 'Gruppo modificato con successo',
          error_modify_group: 'Errore nella modifica del gruppo',
          delete_group: 'Gruppo eliminato con successo',
          error_delete_group: 'Errore eliminazione gruppo',
          open_success: 'Aperture modificate con successo',
          psw_modify: 'Password modificata con successo',
          sede_success: 'Sede modificata con successo',
          error_modify_sede: 'Errore nella modifica della sede',
          utent_success: 'Utente modificato con successo',
          utent_error: 'Errore nella modifica dell\'utente',
          add_theme: 'Tema aggiunto con successo',
          error_theme: 'Errore nell\'aggiunta del tema',
          category_modify: 'Categoria modificata con successo',
          error_modify_category: 'Errore nella modifica della categoria',
          category_delete: 'Categoria eliminata con successo',
          error_delete_category: 'Errore nell\'eliminazione della categoria',
          add_event: 'Evento aggiunto con successo',
          error_event_add: 'Errore durante l\'aggiunta dell\'evento',
          none: 'Impossibile trascinare gli eventi ricorrenti',
          user_add:'Utente aggiunto con successo',
        }

      },
      customers: {
        form_customers: {
          title: 'Aggiungi cliente',
          customer_appointment: 'Ultimi appuntamenti:',
          customer_contact: 'Contatta tramite:',
          customer_name: 'Nome',
          customer_surname: 'Cognome',
          customer_phone: 'numero di telefono',
          customer_email: 'email',
          customer_note: 'note',
          is_sms: 'sms',
          is_email: 'email',
          customer_list: 'lista clienti',
          rubata:' Attenzione, questa mail è già stata registrata'
        },
        edit_customers: {
          title: 'Modifica cliente',
          customer_contact: 'Contatta tramite:',
          customer_name: 'Nome',
          customer_surname: 'Cognome',
          customer_phone: 'numero di telefono',
          customer_email: 'email',
          customer_note: 'note',
          is_sms: 'sms',
          is_email: 'email'
        },
        delete_customers: {
          title: 'Attenzione',
          description: 'Eliminando un cliente non sarà recuperabile, procedere?'
        },
        info_customers: {
          shop: 'Sede: ',
          from: 'Da: ',
          to: 'A: ',
          nots: 'Note: ',
          total: 'Evento giornaliero',
          no_phone: 'Nessun numero di telefono',
          no_mail: 'Nessun indirizzo mail',
          festa:'Compleanno: ',
          oggi_festa:'Oggi è il compleanno di'
        },
        request_customers: {

          title: 'Richieste dei clienti',
          from: 'Da: ',
          time: 'Effettuata il: ',
          for: 'Per il:',
          tel: 'Tel.',
          notes: 'Note:',
          at: 'alle',
          new: 'Nuove richieste di appuntamento arrivate!',
          request_of: 'Richiesta di',
          req_delete:`Richiesta eliminata con successo`,
          err_delete:`Errore eliminazione richiesta`,
          email: "Email:",
          request_delete: {
            title: 'Attenzione',
            delete: 'Sicuri di voler eliminare la richiesta?',

          }

        }
      },
      event: {
        new_event: {
          title: 'Aggiungi evento',
          date: 'Data: ',
          is_apt: 'è un appuntamento?',
          select: 'Seleziona categoria',
          select2: 'Seleziona cliente ',
          name: 'Nome',
          surname: 'Cognome',
          phone: 'Cellulare',
          is_contact: 'Contattare il cliente per ricordargli dell appuntamento?',
          total: 'Tutto il giorno',
          start: 'Inizio:',
          finish: 'Fine:',
          title2: 'Titolo:',
          notes: 'Note:',
          add_customer: 'Aggiungi cliente',
          day:'Giorni',
          week:'Settimane',
          day_week:'Giorno settimana',
          month:'Mese',
          year:'Anno',
          all_day:'Giornaliero',
          ita:'italiano',
          ted:'tedesco',
          ing:'inglese',
          fra:'francese',
          ass:'Assegnato a:'
        },
        info_event: {
          client: 'Cliente: ',
          total: 'Evento giornaliero',
          notes: 'Note: ',
          from: 'Dalle: ',
          to: 'Alle: ',
          date: 'Il giorno: ',
          on_contact: 'il cliente verrà contattato',
          off_contact: 'il cliente non verrà contattato',
          name_app: 'Appuntamento ricorrente',
          event_rec: 'Evento ricorrente?',
          og: 'Ogni:',
          fin_rec: 'Fine ricorrenza',
          fin_description: '*Se non specificata la ricorrenza sarà infinita',
          name_eve: ' Evento ricorsivo ',
          del: 'Attenzione, come si vuole eliminare l evento ricorsivo?',
          back: 'Annulla',
          only: 'Elimina solo questo',
          all: 'Elimina tutti',
          price: 'Prezzo:',
          tot_day:'Tutto il giorno: ',
          ass:'Assegnato a: ',
          cre:'Creato da: ',
          divieto:'Generazione automatica del titolo'

          
        },
        delete_event: {
          title: 'Attenzione ',
          description: 'Sicuro di voler eliminare l evento? non sarà più possibile recuperarlo'
        },
        custom_event: {
          title: 'Modifica evento ',
          date: 'Data: ',
          is_apt: 'è un appuntamento?',
          select: 'Seleziona categoria',
          select2: 'Seleziona cliente ',
          is_contact: 'Contattare il cliente per ricordargli dell appuntamento?',
          total: 'Giornaliero',
          start: 'Inizio:',
          finish: 'Fine:',
          title2: 'Titolo:',
          notes: 'Note:',
          edit: 'Modifica uno',
          edit_all: 'Modifica tutti',
        },
        print_event: {
          title: 'Appuntamento',
          il: 'Il',
          hour: 'Alle ore',
          where: 'Presso'
        },
      },

      Statistics: {
        stats: {
          title: 'Statistiche',
          incasso:'Incasso',
          sms:'Spesa Sms',
          best_cust:'Cliente Migliore',
          worst_cate:'Categoria Peggiore',
          best_cate:'Categoria Migliore',
          inter:' Seleziona intervallo:',
          type:'Seleziona il grafico:',
          dal:'Inizio:',
          al:'Fine:',
          max:'Massimo: ',
          min:'Minimo: ',
          med:'Media: ',
          tot:'Totale: ',
          none_category:'Nessuna categoria',
          none_client:'Nessun cliente',
          isto:'istogramma',
          linea:'lineare',
          year:'Anno',
          month:'Mese',
          week:'Settimana',
          day:'Giorno',
          day_w:'totale giorni settimanali',
          lun:'Lunedì',
          mar:'Martedì',
          mer:'Mercoledì',
          gio:'Giovedì',
          ven:'Venerdì',
          sab:'Sabato',
          dom:'Domenica',
          int:'Intervallo',
        },
      },
    },
    'en-US': {
      sidebar: {
        settings: {
          title: 'User Settings',
          profile: {
            title: 'Profile',
            language_select: 'Select Language',
            language_name: 'English',
            g_account: 'Google Account:',
            g_connect: 'Connected',
            g_disconnect: 'Disconnect',
            g_notconnect: 'Not Connected',
            g_login: 'Login',
            user_username: 'Username',
            user_username_taken: 'Username already in use',
            user_password: 'Password',
            cal_hours_title: 'Calendar View',
            cal_hours_start: 'From',
            cal_hours_end: 'To',
            download: 'Download Price List'
          },
          shop: {
            title: "Location",
            sub_title1: 'Location Settings:',
            shop_select: 'Select Location:',
            shop_name: 'Location Name:',
            shop_sms_name: "SMS Name:",
            language_select: 'Select Language',
            mailer_select: 'Mail Sending Address',
            sub_title2: 'Message Settings',
            message_instructions_text: 'Attention: the following variables must be included in the message:',
            message_instructions_li1: '%name% - customer name',
            message_instructions_li2: '%surname% - customer surname',
            message_instructions_li3: '%time% - appointment time',
            message_label: 'Message',
            message_example: 'Example',
            message_hours: 'Enter how many hours before to send the reminder',
            message_hours_unit: 'Hours',
            psw_change: 'Password changed successfully',
            psw_bleh: 'Password too weak',
            error: 'Generic error, please try again later',
            change_ok: 'Changes saved successfully',
            sub_title3: 'Edit Users:',
            user_select: 'Select User:',
            group_select: 'Permission Group:',
            user_username: 'Username',
            user_password: 'Password',
            day_appo: '%day% - appointment day',
            mex_client: 'Message to the customer',
            fuso:'time zone:',
            pref:'Default prefix:',
            p_auto:'Enable automatic reservations',
            fuso:'Time zone:',
            prepre:'Default prefix:',
            auto_preno:'Enable automatic bookings',
            t_user:'users',
            active_def:'Sms active initially for all customers',
            active_def2:'Email active initially for all customers',
            hour: {
              title: 'Opening Hours:',
              lunedi: 'Monday',
              martedi: 'Tuesday',
              mercoledi: 'Wednesday',
              giovedi: 'Thursday',
              venerdi: 'Friday',
              sabato: 'Saturday',
              domenica: 'Sunday',
              open: 'Open:',
              close: 'Close:',
              close_day: 'Closed'
            },
          },
          groups: {
            title: 'Groups',
            manage_group: 'Manage Groups',
            add_button: 'New Group',
            edit_button: 'Edit Group',
            group_select: 'Select Group:',
            group_name: 'Group Name',
            group_priority: 'Group Priority',
            is_admin: 'Admin',
            view_shops: 'View Locations',
            change_username: 'Change Username',
            us_min: 'Minimum username length: 3 characters',
            us_max: 'Name too long',
            change_password: 'Change Password',
            change_pic: 'Change Image',
            change_hours: 'Change Hours',
            change_theme: 'Change Theme',
            add_theme: 'Add Theme',
            add: 'Add',
            edit: 'Edit',
            delete: 'Delete',
            g_delete: 'This group is linked to users, unlink it before deletion',
            event: 'event',
            apt: 'appointment',
            category: 'category',
            customer: 'customer',
            user: 'user',
            shop: 'location',
            admin_help: 'Allows owning all permissions',
            manage_group_help: 'Allows adding and modifying groups',
            show_shops_help: 'Allows viewing locations other than your own',
            change_username_help: 'Allows changing your own username',
            change_password_help: 'Allows changing the password of your own account',
            change_pic_help: 'Allows changing the image of your own account',
            change_hours_help: 'Allows changing the hourly display of the calendar'
          },
          theme: {
            title: 'Theme',
            theme_select: 'Select Theme'
          },
          save_modal: {
            title: 'Attention',
            body: 'Attention, unsaved data will be deleted',
            cancel: 'Cancel',
            not_save: 'Do Not Save',
            save: 'Save'
          },
          del_modal: {
            title: 'Attention',
            body: 'Once the group is deleted, it cannot be recovered',
            cancel: 'Cancel',
            delete: 'Delete'
          },
          add_theme: {
            title: 'New Theme',
            theme_name: 'Name',
            text_font: 'Text Font',
            title_font: 'Title Font',
            font_dimension: 'Text Size',
            sub_title1: 'Colors:',
            color1: 'Calendar Background:',
            color2: 'General Background',
            color3: 'Sidebar Background',
            color4: 'Dark Text',
            color5: 'Light Text',
            color6: 'Highlighted Objects',
            shadows: 'Shadows',
            shadow_opacity: 'Opacity'
          }
        }
      },
      leftbar: {
        customer_service: {
          title: 'Customer Service',
          body1: 'If you don\'t know how to perform an operation, click the green button to read the manual,',
          body2: 'if you can\'t solve the problem, you can ask for assistance by clicking one of the buttons below or:',
          li1: 'Calling us at ',
          a1: '+41 76 579 4367',
          li2: 'Writing to us at ',
          a2: 'assistenza@nacweb.ch',
        },
        notify: {
          title: 'Latest Notifications',
          none: 'No Notifications'
        },
        exit: {
          title: 'Attention',
          log: 'Are you sure you want to log out?',
          back: 'Cancel',
          continue: 'Confirm'
        }
      },
      calendar: {
        locale: 'en-US',
        today: 'Today',
        view_select: {
          day: 'day',
          week: 'week',
          month: 'month'
        },
        category: {
          title: 'Categories',
          add_category: {
            title: 'Add',
            category_name: 'Name',
            cateogry_time: 'Duration',
            is_apt: 'Is it an appointment category?',
            color: 'Color:',
            title_placeholder: 'shade',
            prev: 'Prevent appointments?',
            description: 'The duration of this event will be considered as closing time, preventing the creation of appointments from online bookings and/or users without permission',
            prev_pren:'Prevent automatic booking',
            previeni: 'Prevent automatic booking',
    permetti: 'Allow automatic booking',
            prev_pren_help: 'If active prevents clients from requesting an appointment with this category',
            cont:'Do you prevent simultaneous appointments?',
            cont_desc:'If active, appointments created with this category will not be able to coincide with other appointments requested by users through online booking.',
            glo:'Visible to all users?',
            glo2:'if active makes events in this category visible to all users in the venue'

          },
          edit_category: {
            title: 'Edit',
            previeni: 'Prevent automatic booking',
            time: 'Duration:',
            select_category: 'Select category to modify',
            category_name: 'Name',
            is_apt: 'Is it an appointment category?',
            color: 'Color:',
            title_placeholder: 'shade',
            prev_pren:'Prevent automatic booking',
          },
          delete_category: {
            title: 'Delete',
            select_category: 'Select category to delete:',
            text_delete: 'Attention! Deletion is irreversible; deleting the category will assign the default color to all events associated with it.'
          }
        },
        warning: {
          title: 'Attention, closing time',
          closed: 'This is marked as closing time, are you sure you want to add an appointment here?'
        },
        notify: {
          add_client: 'Client added successfully',
          error_client: 'Error adding client',
          modify_client: 'Client modified successfully',
          success_modify: 'Event modified successfully',
          error_event: 'Error modifying event',
          error_modify: 'Error modifying client',
          delete_client: 'Client deleted successfully',
          delete_error: 'Error deleting client',
          google_disconnect: 'Google disconnected successfully',
          error_disconnect: 'Error disconnecting from Google',
          success_password: 'Password changed successfully',
          skillissue_psw: 'Password too weak',
          error_psw: 'Error changing password',
          modify_utent: 'User modified successfully',
          used_username: 'Username already in use',
          error_modify_utent: 'Error modifying user',
          success_delete: 'Event deleted successfully',
          error_delete: 'Error deleting event',
          add_category: 'Category added successfully',
          error_category: 'Error adding category',
          add_group: 'Group added successfully',
          error_group: 'Error adding group',
          group_modify: 'Group modified successfully',
          error_modify_group: 'Error modifying group',
          delete_group: 'Group deleted successfully',
          error_delete_group: 'Error deleting group',
          open_success: 'Openings modified successfully',
          psw_modify: 'Password changed successfully',
          sede_success: 'Location modified successfully',
          error_modify_sede: 'Error modifying location',
          utent_success: 'User modified successfully',
          utent_error: 'Error modifying user',
          add_theme: 'Theme added successfully',
          error_theme: 'Error adding theme',
          category_modify: 'Category modified successfully',
          error_modify_category: 'Error modifying category',
          category_delete: 'Category deleted successfully',
          error_delete_category: 'Error deleting category',
          add_event: 'Event added successfully',
          error_event_add: 'Error adding event',
          none: 'Unable to drag recurring events',
          user_add:'User successfully added',
        }
      },
      customers: {
        form_customers: {
          title: 'Add Customer',
          customer_appointment: 'Latest Appointments:',
          customer_contact: 'Contact via:',
          customer_name: 'Name',
          customer_surname: 'Surname',
          customer_phone: 'Phone number',
          customer_email: 'Email',
          customer_note: 'Notes',
          is_sms: 'SMS',
          is_email: 'Email',
          customer_list: 'Customer List',
          rubata:' Warning, this email has already been registered'
        },
        edit_customers: {
          title: 'Edit Customer',
          customer_contact: 'Contact via:',
          customer_name: 'Name',
          customer_surname: 'Surname',
          customer_phone: 'Phone number',
          customer_email: 'Email',
          customer_note: 'Notes',
          is_sms: 'SMS',
          is_email: 'Email'
        },
        delete_customers: {
          title: 'Attention',
          description: 'Deleting a customer will be irreversible, proceed?'
        },
        info_customers: {
          shop: 'Location: ',
          from: 'From: ',
          to: 'To: ',
          nots: 'Notes: ',
          total: 'Daily Event',
          no_phone: 'No phone number',
          no_mail: 'No email address',
          festa:'Birthday: ',
          oggi_festa:'Today is the birthday of '
        },
        request_customers: {
          title: 'Customer Requests',
          from: 'From: ',
          time: 'Made on: ',
          for: 'For:',
          tel: 'Tel.',
          notes: 'Notes:',
          at: 'at',
          new: 'New appointment requests received!',
          request_of: 'Request for',
          req_delete:`Request successfully deleted`,
          err_delete:`Error deleting request`,
          email: "Email:",
          request_delete: {
            title: 'Attention',
            delete: 'Are you sure you want to delete the request?',
          }
        }
      },
      event: {
        new_event: {
          title: 'Add Event',
          date: 'Date: ',
          is_apt: 'Is it an appointment?',
          select: 'Select category',
          select2: 'Select client',
          name: 'First Name',
          surname: 'Last Name',
          phone: 'Phone',
          is_contact: 'Contact the client to remind them of the appointment?',
          total: 'All day',
          start: 'Start:',
          finish: 'End:',
          title2: 'Title:',
          notes: 'Notes:',
          add_customer: 'Add customer',
          day: 'Days',
          week: 'Weeks',
          day_week: 'Day of the week',
          month: 'Month',
          Year: 'Year',
          all_day: 'All day',
          ita: 'Italian',
          ted: 'German',
          ing: 'English',
          fra: 'French',
          ass:'assigned to :'
        },
        info_event: {
          client: 'Client: ',
          total: 'Daily Event',
          notes: 'Notes: ',
          from: 'From: ',
          to: 'To: ',
          date: 'On: ',
          on_contact: 'the customer will be contacted',
          off_contact: 'the customer will not be contacted',
          name_app: 'Recurring Appointment',
          event_rec: 'Recurring Event?',
          og: 'Every:',
          fin_rec: 'Recurrence end',
          fin_description: '*If not specified, the recurrence will be infinite',
          name_eve: ' Recursive Event ',
          del: 'Attention, how do you want to delete the recurring event?',
          back: 'Cancel',
          only: 'Delete only this',
          all: 'Delete all',
          price: 'Price:',
          tot_day:'All day: ',
          ass:'assigned to: ',
          cre:'Created by: ',
          divieto:'Automatic title generation '
        },
        delete_event: {
          title: 'Attention ',
          description: 'Are you sure you want to delete the event? It will no longer be recoverable'
        },
        custom_event: {
          title: 'Edit Event ',
          date: 'Date: ',
          is_apt: 'Is it an appointment?',
          select: 'Select category',
          select2: 'Select customer',
          is_contact: 'Contact the customer to remind them of the appointment?',
          total: 'Daily',
          start: 'Start:',
          finish: 'Finish:',
          title2: 'Title:',
          edit: 'Edit one',
          edit_all: 'Edit all',
          notes: 'Notes:'
        },
        print_event: {
          title: 'Appointment',
          il: 'On',
          hour: 'at',
          where: 'At'
        },
      },
      Statistics: {
        stats: {
          title: 'Statistics',
          incasso: 'Revenue',
          sms: 'SMS Expense',
          best_cust: 'Best Customer',
          worst_cate: 'Worst Category',
          best_cate: 'Best Category',
          inter: 'Select Interval:',
          type: 'Select Chart Type:',
          dal: 'From:',
          al: 'To:',
          max: 'Maximum: ',
          min: 'Minimum: ',
          med: 'Average: ',
          tot: 'Total: ',
          none_category: 'No Category',
          none_client: 'No Customer',
          isto: 'Histogram',
          linea: 'Line',
          year: 'Year',
          month: 'Month',
          week: 'Week',
          day: 'Day',
          day_w: 'Total Days of the Week',
          lun: 'Monday',
          mar: 'Tuesday',
          mer: 'Wednesday',
          gio: 'Thursday',
          ven: 'Friday',
          sab: 'Saturday',
          dom: 'Sunday',
          int:'Range',
        },
      },
    },
    'de-DE': {
      sidebar: {
        settings: {
          title: 'Benutzereinstellungen',
          profile: {
            title: 'Profil',
            language_select: 'Sprache auswählen',
            language_name: 'Deutsch',
            g_account: 'Google-Konto:',
            g_connect: 'Verbunden',
            g_disconnect: 'Trennen',
            g_notconnect: 'Nicht verbunden',
            g_login: 'Einloggen',
            user_username: 'Benutzername',
            user_username_taken: 'Benutzername bereits in Verwendung',
            user_password: 'Passwort',
            cal_hours_title: 'Kalenderansicht',
            cal_hours_start: 'Von',
            cal_hours_end: 'Bis',
            download: 'Preisliste herunterladen'
          },
          shop: {
            title: "Hauptsitz",
            sub_title1: 'Filial-Einstellungen:',
            shop_select: 'Hauptsitz auswählen:',
            shop_name: 'Hauptsitzname:',
            shop_sms_name: "SMS-Name:",
            language_select: 'Sprache auswählen',
            mailer_select: 'E-Mail-Versandadresse',
            sub_title2: 'Nachrichteneinstellungen',
            message_instructions_text: 'Achtung: In der Nachricht müssen die folgenden Variablen eingefügt werden:',
            message_instructions_li1: '%name% - Vorname des Kunden',
            message_instructions_li2: '%surname% - Nachname des Kunden',
            message_instructions_li3: '%time% - Uhrzeit des Termins',
            message_label: 'Nachricht',
            message_example: 'Beispiel',
            message_hours: 'Stunden vor dem Termin festlegen, zu dem die Erinnerung gesendet werden soll',
            message_hours_unit: 'Stunden',
            psw_change: 'Passwort erfolgreich geändert',
            psw_bleh: 'Passwort zu schwach',
            error: 'Allgemeiner Fehler, bitte versuchen Sie es später erneut',
            change_ok: 'Änderung erfolgreich durchgeführt',
            sub_title3: 'Benutzer bearbeiten:',
            user_select: 'Benutzer auswählen:',
            group_select: 'Berechtigungsgruppe:',
            user_username: 'Benutzername',
            user_password: 'Passwort',
            day_appo: '%day% - Tag des Termins',
            mex_client: 'Nachricht an den Kunden',
            fuso:'Zeitzone',
            pref:'Standard-Präfix:',
            p_auto:'Automatische Buchungen aktivieren ',
            fuso:'Zeitzone:',
            prepre:'Standardpräfix:',
            auto_preno:'Automatische Buchungen aktivieren',
            t_user:'Benutzer',
            active_def:'Sms zunächst für alle Kunden aktiv',
            active_def2:'Emails zunächst für alle Kunden aktiv',
            hour: {
              title: 'Öffnungszeiten:',
              lunedi: 'Montag',
              martedi: 'Dienstag',
              mercoledi: 'Mittwoch',
              giovedi: 'Donnerstag',
              venerdi: 'Freitag',
              sabato: 'Samstag',
              domenica: 'Sonntag',
              open: 'Öffnung:',
              close: 'Schließung:',
              close_day: 'Geschlossen'
            },
          },
          groups: {
            title: 'Gruppen',
            manage_group: 'Gruppen verwalten',
            add_button: 'Neue Gruppe',
            edit_button: 'Gruppe bearbeiten',
            group_select: 'Gruppe auswählen:',
            group_name: 'Gruppenname',
            group_priority: 'Gruppenpriorität',
            is_admin: 'Admin',
            view_shops: 'Hauptsitz anzeigen',
            change_username: 'Benutzernamen ändern',
            us_min: 'Minimale Länge des Namens: 3 Zeichen',
            us_max: 'Name zu lang',
            change_password: 'Passwort ändern',
            change_pic: 'Bild ändern',
            change_hours: 'Öffnungszeiten ändern',
            change_theme: 'Thema ändern',
            add_theme: 'Thema hinzufügen',
            add: 'Hinzufügen',
            edit: 'Bearbeiten',
            delete: 'Löschen',
            g_delete: 'Diese Gruppe ist mit Benutzern verknüpft. Bitte trennen Sie sie, bevor Sie sie löschen.',
            event: 'Ereignis',
            apt: 'Termin',
            category: 'Kategorie',
            customer: 'Kunde',
            user: 'Benutzer',
            shop: 'Hauptsitz',
            admin_help: 'Ermöglicht den Besitz aller Berechtigungen',
            manage_group_help: 'Ermöglicht das Hinzufügen und Bearbeiten von Gruppen',
            show_shops_help: 'Ermöglicht das Anzeigen von Hauptsitz außerhalb der eigenen',
            change_username_help: 'Ermöglicht das Ändern des eigenen Benutzernamens',
            change_password_help: 'Ermöglicht das Ändern des Passworts des eigenen Kontos',
            change_pic_help: 'Ermöglicht das Ändern des Bildes des eigenen Kontos',
            change_hours_help: 'Ermöglicht das Ändern der Stundenansicht im Kalender'
          },
          theme: {
            title: 'Design',
            theme_select: 'Design auswählen'
          },
          save_modal: {
            title: 'Achtung',
            body: 'Achtung, nicht gespeicherte Daten werden gelöscht',
            cancel: 'Abbrechen',
            not_save: 'Nicht speichern',
            save: 'Speichern'
          },
          del_modal: {
            title: 'Achtung',
            body: 'Einmal gelöschte Gruppen können nicht wiederhergestellt werden',
            cancel: 'Abbrechen',
            delete: 'Löschen'
          },
          add_theme: {
            title: 'Neues Design',
            theme_name: 'Name',
            text_font: 'Textschriftart',
            title_font: 'Überschriftschriftart',
            font_dimension: 'Textgröße',
            sub_title1: 'Farben:',
            color1: 'Kalenderhintergrund:',
            color2: 'Allgemeiner Hintergrund',
            color3: 'Seitenleistenhintergrund',
            color4: 'Dunkler Text',
            color5: 'Heller Text',
            color6: 'Hervorgehobene Objekte',
            shadows: 'Schatten',
            shadow_opacity: 'Deckkraft'
          }
        }
      },
      leftbar: {
        customer_service: {
          title: 'Kundendienst',
          body1: 'Wenn Sie nicht wissen, wie Sie eine Aktion durchführen sollen, klicken Sie auf die grüne Schaltfläche, um das Handbuch zu lesen.',
          body2: 'Wenn Sie das Problem nicht lösen können, können Sie uns um Hilfe bitten, indem Sie eine der Schaltflächen unten anklicken oder:',
          li1: 'Rufen Sie uns an unter ',
          a1: '+41 76 579 4367',
          li2: 'Schreiben Sie uns an ',
          a2: 'assistenza@nacweb.ch',
        },
        notify: {
          title: 'Letzte Benachrichtigungen',
          none: 'Keine Benachrichtigungen'
        },
        exit: {
          title: 'Achtung',
          log: 'Sind Sie sicher, dass Sie sich abmelden möchten?',
          back: 'Abbrechen',
          continue: 'Bestätigen'
        }
      },
      calendar: {
        locale: 'de-DE',
        today: 'Heute',
        view_select: {
          day: 'Tag',
          week: 'Woche',
          month: 'Monat'
        },
        category: {
          title: 'Kategorien',
          add_category: {
            title: 'Hinzufügen',
            category_name: 'Name',
            cateogry_time: 'Dauer',
            is_apt: 'Ist es eine Termin-Kategorie?',
            color: 'Farbe:',
            title_placeholder: 'Farbton',
            prev: 'Verhindert Termine?',
            description: 'Der Zeitraum dieses Ereignisses wird als Schließzeit betrachtet, sodass keine Termine aus Online-Buchungen oder von Benutzern ohne Berechtigung erstellt werden können.',
            prev_pren:'Automatische Buchung verhindern',
            previeni: 'Automatische Buchung verhindern',
    permetti: 'Automatische Buchung erlauben',
            prev_pren_help: 'Wenn diese Option aktiviert ist, verhindert sie, dass Kunden einen Termin mit dieser Kategorie anfragen.',
            cont:'Planen Sie Termine zur gleichen Zeit?',
            cont_desc:'Wenn diese Option aktiviert ist, können Termine, die mit dieser Kategorie erstellt wurden, nicht mit anderen Terminen zusammenfallen, die von Benutzern über die Online-Buchung angefordert wurden.',
            glo:'Sichtbar für alle Benutzer?',
            glo2:' Wenn diese Option aktiviert ist, sind die Veranstaltungen in dieser Kategorie für alle Benutzer des Veranstaltungsortes sichtbar. '
          
            },
          edit_category: {
            title: 'Bearbeiten',
            previeni: 'Automatische Buchung verhindern',
            time: 'Dauer:',
            select_category: 'Kategorie zum Bearbeiten auswählen',
            category_name: 'Name',
            is_apt: 'Ist es eine Termin-Kategorie?',
            color: 'Farbe:',
            title_placeholder: 'Farbton',
            prev_pren:'Automatische Buchung verhindern',
          },
          delete_category: {
            title: 'Löschen',
            select_category: 'Zu löschende Kategorie auswählen:',
            text_delete: 'Achtung! Das Löschen ist nicht rückgängig zu machen. Durch das Löschen der Kategorie wird allen damit verbundenen Ereignissen die Standardfarbe zugewiesen.'
          }
        },
        warning: {
          title: 'Achtung, Schließzeit',
          closed: 'Dies ist als Schließzeit markiert. Sind Sie sicher, dass Sie hier einen Termin hinzufügen möchten?'
        },
        notify: {
          add_client: 'Kunde erfolgreich hinzugefügt',
          error_client: 'Fehler beim Hinzufügen des Kunden',
          modify_client: 'Kunde erfolgreich geändert',
          success_modify: 'Ereignis erfolgreich geändert',
          error_event: 'Fehler bei der Änderung des Ereignisses',
          error_modify: 'Fehler bei der Änderung des Kunden',
          delete_client: 'Kunde erfolgreich gelöscht',
          delete_error: 'Fehler beim Löschen des Kunden',
          google_disconnect: 'Google erfolgreich getrennt',
          error_disconnect: 'Fehler beim Trennen von Google',
          success_password: 'Passwort erfolgreich geändert',
          skillissue_psw: 'Passwort zu schwach',
          error_psw: 'Fehler bei der Änderung des Passworts',
          modify_utent: 'Benutzer erfolgreich geändert',
          used_username: 'Benutzername bereits in Verwendung',
          error_modify_utent: 'Fehler bei der Änderung des Benutzers',
          success_delete: 'Ereignis erfolgreich gelöscht',
          error_delete: 'Fehler beim Löschen des Ereignisses',
          add_category: 'Kategorie erfolgreich hinzugefügt',
          error_category: 'Fehler beim Hinzufügen der Kategorie',
          add_group: 'Gruppe erfolgreich hinzugefügt',
          error_group: 'Fehler beim Hinzufügen der Gruppe',
          group_modify: 'Gruppe erfolgreich geändert',
          error_modify_group: 'Fehler bei der Änderung der Gruppe',
          delete_group: 'Gruppe erfolgreich gelöscht',
          error_delete_group: 'Fehler beim Löschen der Gruppe',
          open_success: 'Öffnungszeiten erfolgreich geändert',
          psw_modify: 'Passwort erfolgreich geändert',
          sede_success: 'Hauptsitz erfolgreich geändert',
          error_modify_sede: 'Fehler bei der Änderung der Hauptsitz',
          utent_success: 'Benutzer erfolgreich geändert',
          utent_error: 'Fehler bei der Änderung des Benutzers',
          add_theme: 'Design erfolgreich hinzugefügt',
          error_theme: 'Fehler beim Hinzufügen des Designs',
          category_modify: 'Kategorie erfolgreich geändert',
          error_modify_category: 'Fehler bei der Änderung der Kategorie',
          category_delete: 'Kategorie erfolgreich gelöscht',
          error_delete_category: 'Fehler beim Löschen der Kategorie',
          add_event: 'Ereignis erfolgreich hinzugefügt',
          error_event_add: 'Fehler beim Hinzufügen des Ereignisses',
          none: 'Wiederkehrende Ereignisse können nicht verschoben werden',
          user_add:'Benutzer erfolgreich hinzugefügt',
        }
      },
      customers: {
        form_customers: {
          title: 'Kunden hinzufügen',
          customer_appointment: 'Letzte Termine:',
          customer_contact: 'Kontaktieren Sie über:',
          customer_name: 'Vorname',
          customer_surname: 'Nachname',
          customer_phone: 'Telefonnummer',
          customer_email: 'E-Mail',
          customer_note: 'Notiz',
          is_sms: 'SMS',
          is_email: 'E-Mail',
          customer_list: 'Kundenliste',
          rubata:' Achtung, diese E-Mail wurde bereits registriert'
        },
        edit_customers: {
          title: 'Kunde bearbeiten',
          customer_contact: 'Kontaktieren Sie über:',
          customer_name: 'Vorname',
          customer_surname: 'Nachname',
          customer_phone: 'Telefonnummer',
          customer_email: 'E-Mail',
          customer_note: 'Notiz',
          is_sms: 'SMS',
          is_email: 'E-Mail'
        },
        delete_customers: {
          title: 'Achtung',
          description: 'Ein gelöschter Kunde kann nicht wiederhergestellt werden. Fortfahren?'
        },
        info_customers: {
          shop: 'Hauptsitz: ',
          from: 'Von: ',
          to: 'Bis: ',
          nots: 'Notizen: ',
          total: 'Tägliches Ereignis',
          no_phone: 'Keine Telefonnummer angegeben',
          no_mail: 'Keine E-Mail-Adresse angegeben',
          festa:' Geburtstag: ',
          oggi_festa:'Heute ist der Geburtstag von '
        },
        request_customers: {
          title: 'Kundenanfragen',
          from: 'Von: ',
          time: 'Erstellt am: ',
          for: 'Für den:',
          tel: 'Tel.',
          notes: 'Notizen:',
          at: 'um',
          new: 'Neue Terminanfragen eingegangen!',
          request_of: 'Anfrage von',
          req_delete:`Anfrage erfolgreich gelöscht`,
          err_delete:`Fehler beim Löschen von Anträgen`,
          email: "Email:",
          request_delete: {
            title: 'Achtung',
            delete: 'Sind Sie sicher, dass Sie die Anfrage löschen möchten?'
          }
        }
      },
      event: {
        new_event: {
          title: 'Ereignis hinzufügen',
          date: 'Datum: ',
          is_apt: 'Ist es ein Termin?',
          select: 'Kategorie auswählen',
          select2: 'Kunde auswählen ',
          name: 'Vorname',
          surname: 'Nachname',
          phone: 'Handy',
          is_contact: 'Kunden kontaktieren, um ihn an den Termin zu erinnern?',
          total: 'Ganztägig',
          start: 'Beginn:',
          finish: 'Ende:',
          title2: 'Titel:',
          notes: 'Notizen:',
          add_customer: 'Kunde hinzufügen',
          day: 'Tage',
          week: 'Wochen',
          day_week: 'Wochentag',
          month: 'Monat',
          Year: 'Jahr',
          all_day: 'Ganztägig',
          ita: 'Italienisch',
          ted: 'Deutsch',
          ing: 'Englisch',
          fra: 'Französisch',
          ass:'zugewiesen:'
        },
        info_event: {
          client: 'Kunde: ',
          total: 'Tägliches Ereignis',
          notes: 'Notizen: ',
          from: 'Von: ',
          to: 'Bis: ',
          date: 'Am Tag: ',
          on_contact: 'Der Kunde wird kontaktiert',
          off_contact: 'Der Kunde wird nicht kontaktiert',
          name_app: 'Wiederkehrender Termin',
          event_rec: 'Wiederkehrendes Ereignis?',
          og: 'Jede:',
          fin_rec: 'Ende der Wiederholung',
          fin_description: '*Wenn nicht spezifiziert, wird die Wiederholung unendlich sein',
          name_eve: ' Wiederkehrendes Ereignis ',
          del: 'Achtung, wie soll das wiederkehrende Ereignis gelöscht werden?',
          back: 'Abbrechen',
          only: 'Nur dieses löschen',
          all: 'Alle löschen',
          price: 'Preis:',
          tot_day:'Ganztägig : ',
          ass:'zugewiesen: ',
          cre:'Erstellt von: ',
          divieto:' Automatische Titelgenerierung '
        },
        delete_event: {
          title: 'Achtung ',
          description: 'Sind Sie sicher, dass Sie das Ereignis löschen möchten? Es kann nicht wiederhergestellt werden'
        },
        custom_event: {
          title: 'Ereignis bearbeiten ',
          date: 'Datum: ',
          is_apt: 'Ist ein Termin?',
          select: 'Kategorie auswählen',
          select2: 'Kunde auswählen',
          is_contact: 'Soll der Kunde für den Termin kontaktiert werden?',
          total: 'Täglich',
          start: 'Beginn:',
          finish: 'Ende:',
          title2: 'Titel:',
          edit: 'Eines bearbeiten',
          edit_all: 'Alle bearbeiten',
          notes: 'Notizen:'
        },
        print_event: {
          title: 'Termin',
          il: 'Am',
          hour: 'Um',
          where: 'Bei'
        },
      },
      Statistics: {
        stats: {
          title: 'Statistiken',
          incasso: 'Einnahmen',
          sms: 'SMS-Ausgaben',
          best_cust: 'Bester Kunde',
          worst_cate: 'Schlechteste Kategorie',
          best_cate: 'Beste Kategorie',
          inter: 'Wähle Intervall:',
          type: 'Wähle Diagrammtyp:',
          dal: 'Von:',
          al: 'Bis:',
          max: 'Maximal: ',
          min: 'Minimal: ',
          med: 'Durchschnitt: ',
          tot: 'Insgesamt: ',
          none_category: 'Keine Kategorie',
          none_client: 'Kein Kunde',
          isto: 'Histogramm',
          linea: 'Linie',
          year: 'Jahr',
          month: 'Monat',
          week: 'Woche',
          day: 'Tag',
          day_w: 'Tage Woche insgesamt',
          lun: 'Montag',
          mar: 'Dienstag',
          mer: 'Mittwoch',
          gio: 'Donnerstag',
          ven: 'Freitag',
          sab: 'Samstag',
          dom: 'Sonntag',
          int:'Intervall',
        },
      },
    },
    'fr-FR': {
      sidebar: {
        settings: {
          title: 'Paramètres utilisateur',
          profile: {
            title: 'Profil',
            language_select: 'Sélectionnez la langue',
            language_name: 'Français',
            g_account: 'Compte Google :',
            g_connect: 'Connecté',
            g_disconnect: 'Déconnexion',
            g_notconnect: 'Non connecté',
            g_login: 'Se connecter',
            user_username: 'Nom d\'utilisateur',
            user_username_taken: 'Nom d\'utilisateur déjà utilisé',
            user_password: 'Mot de passe',
            cal_hours_title: 'Affichage du calendrier',
            cal_hours_start: 'De',
            cal_hours_end: 'À',
            download: 'Télécharger la tarification'
          },
          shop: {
            title: "Emplacement",
            sub_title1: 'Paramètres de l\'emplacement :',
            shop_select: 'Sélectionnez l\'emplacement :',
            shop_name: 'Nom de l\'emplacement :',
            shop_sms_name: "Nom sur SMS :",
            language_select: 'Sélectionnez la langue',
            mailer_select: 'Adresse d\'envoi du courrier',
            sub_title2: 'Paramètres du message',
            message_instructions_text: 'Attention, les variables suivantes doivent être incluses dans le message :',
            message_instructions_li1: '%name% - nom du client',
            message_instructions_li2: '%surname% - nom de famille du client',
            message_instructions_li3: '%time% - heure du rendez-vous',
            message_label: 'Message',
            message_example: 'Exemple',
            message_hours: 'Indiquez combien d\'heures avant l\'envoi du rappel',
            message_hours_unit: 'Heures',
            psw_change: 'Mot de passe changé avec succès',
            psw_bleh: 'Mot de passe trop faible',
            error: 'Erreur générale, réessayez plus tard',
            change_ok: 'Modification réussie',
            sub_title3: 'Modifier les utilisateurs :',
            user_select: 'Sélectionnez l\'utilisateur :',
            group_select: 'Groupe d\'autorisation :',
            user_username: 'Nom d\'utilisateur',
            user_password: 'Mot de passe',
            day_appo: '%day% - jour du rendez-vous',
            mex_client: 'Message au client',
            fuso:'Fuseau horaire',
            pref:'Préfixe par défaut :',
            p_auto:'Activer les réservations automatiques',
            fuso:'Fuseau horaire :',
    prepre:'Préfixe par défaut :',
    auto_preno:'Activer les réservations automatiques',
    t_user:'utilisateurs',
    active_def:'Sms initialement actif pour tous les clients',
    active_def2:'Email initialement actifs pour tous les clients',

            hour: {
              title: 'Heures d\'ouverture :',
              lunedi: 'Lundi',
              martedi: 'Mardi',
              mercoledi: 'Mercredi',
              giovedi: 'Jeudi',
              venerdi: 'Vendredi',
              sabato: 'Samedi',
              domenica: 'Dimanche',
              open: 'Début :',
              close: 'Fin :',
              close_day: 'Fermé'
            },
          },
          groups: {
            title: 'Groupes',
            manage_group: 'Gérer les groupes',
            add_button: 'Nouveau groupe',
            edit_button: 'Modifier le groupe',
            group_select: 'Sélectionnez le groupe :',
            group_name: 'Nom du groupe',
            group_priority: 'Priorité du groupe',
            is_admin: 'Admin',
            view_shops: 'Afficher les emplacements',
            change_username: 'Changer de nom d\'utilisateur',
            us_min: 'Longueur minimale du nom : 3 caractères',
            us_max: 'Nom trop long',
            change_password: 'Changer le mot de passe',
            change_pic: 'Changer d\'image',
            change_hours: 'Modifier les heures',
            change_theme: 'Changer de thème',
            add_theme: 'Ajouter un thème',
            add: 'Ajouter',
            edit: 'Modifier',
            delete: 'Supprimer',
            g_delete: 'Ce groupe est lié à des utilisateurs, déconnectez-le avant la suppression',
            event: 'événement',
            apt: 'rendez-vous',
            category: 'catégorie',
            customer: 'client',
            user: 'utilisateur',
            shop: 'emplacement',
            admin_help: 'Permet de posséder toutes les autorisations',
            manage_group_help: 'Permet d\'ajouter et de modifier des groupes',
            show_shops_help: 'Permet d\'afficher des emplacements autres que le sien',
            change_username_help: 'Permet de changer son propre nom d\'utilisateur',
            change_password_help: 'Permet de modifier le mot de passe de son propre compte',
            change_pic_help: 'Permet de changer l\'image de son propre compte',
            change_hours_help: 'Permet de modifier l\'affichage horaire du calendrier'
          },
          theme: {
            title: 'Thème',
            theme_select: 'Sélectionnez le thème'
          },
          save_modal: {
            title: 'Attention',
            body: 'Attention, les données non enregistrées seront supprimées',
            cancel: 'Annuler',
            not_save: 'Ne pas enregistrer',
            save: 'Enregistrer'
          },
          del_modal: {
            title: 'Attention',
            body: 'Une fois le groupe supprimé, il ne pourra pas être récupéré',
            cancel: 'Annuler',
            delete: 'Supprimer'
          },
          add_theme: {
            title: 'Nouveau thème',
            theme_name: 'Nom',
            text_font: 'Police de texte',
            title_font: 'Police de titre',
            font_dimension: 'Dimension du texte',
            sub_title1: 'Couleurs :',
            color1: 'Fond du calendrier :',
            color2: 'Fond général',
            color3: 'Fond de la barre latérale',
            color4: 'Texte foncé',
            color5: 'Texte clair',
            color6: 'Objets en surbrillance',
            shadows: 'Ombres',
            shadow_opacity: 'Opacité'
          }
        }
      },
      leftbar: {
        customer_service: {
          title: 'Service client',
          body1: 'Si vous ne savez pas comment effectuer une opération, cliquez sur le bouton vert pour lire le manuel,',
          body2: 'si vous ne parvenez pas à résoudre le problème, vous pouvez demander de l\'aide en cliquant sur l\'un des boutons ci-dessous ou :',
          li1: 'En nous appelant au ',
          a1: '+41 76 579 4367',
          li2: 'En nous écrivant à ',
          a2: 'assistenza@nacweb.ch',
        },
        notify: {
          title: 'Dernières notifications',
          none: 'Aucune notification'
        },
        exit: {
          title: 'Attention',
          log: 'Êtes-vous sûr de vouloir vous déconnecter ?',
          back: 'Annuler',
          continue: 'Confirmer'
        }

      },
      calendar: {
        locale: 'fr-FR',
        today: 'Aujourd\'hui',
        view_select: {
          day: 'jour',
          week: 'semaine',
          month: 'mois'
        },
        category: {
          title: 'Catégories',
          add_category: {
            title: 'Ajouter',
            category_name: 'Nom',
            cateogry_time: 'Durée',
            is_apt: 'Est une catégorie de rendez-vous ?',
            color: 'Couleur :',
            title_placeholder: 'teinte',
            prev: 'Empêcher les rendez-vous ?',
            description: 'La période de durée de cet événement sera considérée comme une heure de fermeture, de cette manière, il ne sera pas possible de créer des rendez-vous à partir des réservations en ligne et/ou des utilisateurs sans autorisation',
            prev_pren:'Empêcher la réservation automatique',
            previeni: 'Empêcher la réservation automatique',
    permetti: 'Autoriser la réservation automatique',
            prev_pren_help: 'Si cette option est activée, elle empêche les clients de demander un rendez-vous dans cette catégorie.',
            cont:'Prenez-vous vos rendez-vous à la même heure ?',
            cont_desc:'Si cette option est activée, les rendez-vous créés avec cette catégorie ne peuvent pas coïncider avec d\'autres rendez-vous demandés par les utilisateurs via la réservation en ligne.',
            glo:'Visible pour tous les utilisateurs ?',
            glo2:'s\'il est actif, les événements de cette catégorie sont visibles par tous les utilisateurs du site. '
          
          },
          edit_category: {
            title: 'Modifier',
            previeni: 'Empêcher la réservation automatique',
            time: 'Durée :',
            select_category: 'Sélectionnez la catégorie à modifier',
            category_name: 'Nom',
            is_apt: 'Est une catégorie de rendez-vous ?',
            color: 'Couleur :',
            title_placeholder: 'teinte',
            prev_pren:'Empêcher la réservation automatique',
          },
          delete_category: {
            title: 'Supprimer',
            select_category: 'Sélectionnez la catégorie à supprimer :',
            text_delete: 'Attention ! La suppression n\'est pas réversible, en supprimant la catégorie, la couleur par défaut sera attribuée à tous les événements qui lui sont associés.'
          }
        },
        warning: {
          title: 'Attention, heure de fermeture',
          closed: 'Ceci est marqué comme une heure de fermeture, êtes-vous sûr de vouloir ajouter un rendez-vous ici ?'
        },
        notify: {
          add_client: 'Client ajouté avec succès',
          error_client: 'Erreur lors de l\'ajout du client',
          modify_client: 'Client modifié avec succès',
          success_modify: 'Événement modifié avec succès',
          error_event: 'Erreur dans la modification de l\'événement',
          error_modify: 'Erreur dans la modification du client',
          delete_client: 'Client supprimé avec succès',
          delete_error: 'Erreur dans la suppression du client',
          google_disconnect: 'Google déconnecté avec succès',
          error_disconnect: 'Erreur de déconnexion de Google',
          success_password: 'Mot de passe modifié avec succès',
          skillissue_psw: 'Mot de passe trop faible',
          error_psw: 'Erreur dans la modification du mot de passe',
          modify_utent: 'Utilisateur modifié avec succès',
          used_username: 'Nom d\'utilisateur déjà utilisé',
          error_modify_utent: 'Erreur dans la modification de l\'utilisateur',
          success_delete: 'Événement supprimé avec succès',
          error_delete: 'Erreur lors de la suppression de l\'événement',
          add_category: 'Catégorie ajoutée avec succès',
          error_category: 'Erreur lors de l\'ajout de la catégorie',
          add_group: 'Groupe ajouté avec succès',
          error_group: 'Erreur dans l\'ajout du groupe',
          group_modify: 'Groupe modifié avec succès',
          error_modify_group: 'Erreur dans la modification du groupe',
          delete_group: 'Groupe supprimé avec succès',
          error_delete_group: 'Erreur de suppression du groupe',
          open_success: 'Heures d\'ouverture modifiées avec succès',
          psw_modify: 'Mot de passe modifié avec succès',
          sede_success: 'Emplacement modifié avec succès',
          error_modify_sede: 'Erreur dans la modification de l\'emplacement',
          utent_success: 'Utilisateur modifié avec succès',
          utent_error: 'Erreur dans la modification de l\'utilisateur',
          add_theme: 'Thème ajouté avec succès',
          error_theme: 'Erreur lors de l\'ajout du thème',
          category_modify: 'Catégorie modifiée avec succès',
          error_modify_category: 'Erreur dans la modification de la catégorie',
          category_delete: 'Catégorie supprimée avec succès',
          error_delete_category: 'Erreur lors de la suppression de la catégorie',
          add_event: 'Événement ajouté avec succès',
          error_event_add: 'Erreur lors de l\'ajout de l\'événement',
          none: 'Impossible de faire glisser les événements récurrents',
          user_add:'L\'utilisateur a été ajouté avec succès erfolgreich hinzugefügt',
        }
      },
      customers: {
        form_customers: {
          title: 'Ajouter un client',
          customer_appointment: 'Derniers rendez-vous :',
          customer_contact: 'Contacter via :',
          customer_name: 'Nom',
          customer_surname: 'Nom de famille',
          customer_phone: 'Numéro de téléphone',
          customer_email: 'Courriel',
          customer_note: 'Note',
          is_sms: 'SMS',
          is_email: 'Courriel',
          customer_list: 'Liste des clients',
          rubata:' Attention, cet e-mail a déjà été enregistré'
        },
        edit_customers: {
          title: 'Modifier le client',
          customer_contact: 'Contacter via :',
          customer_name: 'Nom',
          customer_surname: 'Nom de famille',
          customer_phone: 'Numéro de téléphone',
          customer_email: 'Courriel',
          customer_note: 'Note',
          is_sms: 'SMS',
          is_email: 'Courriel'
        },
        delete_customers: {
          title: 'Attention',
          description: 'En supprimant un client, il ne pourra pas être récupéré. Voulez-vous continuer ?'
        },
        info_customers: {
          shop: 'Emplacement : ',
          from: 'De : ',
          to: 'À : ',
          nots: 'Notes : ',
          total: 'Événement quotidien',
          no_phone: 'Pas de numéro de téléphone',
          no_mail: 'Pas d\'adresse courriel',
          festa:'anniversaire: ',
          oggi_festa:'Aujourd\'hui, c\'est l\'anniversaire de '
        },
        request_customers: {
          title: 'Demandes de clients',
          from: 'De : ',
          time: 'Effectué le : ',
          for: 'Pour le :',
          tel: 'Tél.',
          notes: 'Notes :',
          at: 'à',
          new: 'Nouvelles demandes de rendez-vous reçues !',
          request_of: 'Demande de',
          req_delete:`Demande supprimée avec succès`,
          err_delete:`Erreur de suppression de la demande`,
          email: "Courriel:",
          request_delete: {
            title: 'Attention',
            delete: 'Êtes-vous sûr de vouloir supprimer la demande ?',
          }
        }
      },
      event: {
        new_event: {
          title: 'Ajouter un événement',
          date: 'Date : ',
          is_apt: 'Est-ce un rendez-vous ?',
          select: 'Sélectionner la catégorie',
          select2: 'Sélectionner le client',
          name: 'Prénom',
          surname: 'Nom de famille',
          phone: 'Téléphone',
          is_contact: 'Contacter le client pour lui rappeler le rendez-vous ?',
          total: 'Toute la journée',
          start: 'Début :',
          finish: 'Fin :',
          title2: 'Titre :',
          notes: 'Notes :',
          add_customer: 'Ajouter un client',
          day: 'Jours',
          week: 'Semaines',
          day_week: 'Jour de la semaine',
          month: 'Mois',
          Year: 'Année',
          all_day: 'Toute la journée',
          ita: 'Italien',
          ted: 'Allemand',
          ing: 'Anglais',
          fra: 'Français',
          ass:'alloués à: '
        },
        info_event: {
          client: 'Client : ',
          total: 'Événement quotidien',
          notes: 'Notes : ',
          from: 'De : ',
          to: 'À : ',
          date: 'Le jour : ',
          on_contact: 'le client sera contacté',
          off_contact: 'le client ne sera pas contacté',
          name_app: 'Rendez-vous récurrent',
          event_rec: 'Événement récurrent ?',
          og: 'Chaque :',
          fin_rec: 'Fin de la récurrence',
          fin_description: '*Si non spécifiée, la récurrence sera infinie',
          name_eve: ' Événement récursif ',
          del: 'Attention, comment voulez-vous supprimer l\'événement récurrent ?',
          back: 'Annuler',
          only: 'Supprimer seulement celui-ci',
          all: 'Supprimer tous',
          price: 'Prix :',
          tot_day:'Toute la journée : ',
          ass:'alloués à: ',
          cre:'Créé par: ',
          divieto:' Automatische Titelgenerierung '
          
        },
        delete_event: {
          title: 'Attention ',
          description: 'Êtes-vous sûr de vouloir supprimer l\'événement ? Il ne sera plus récupérable'
        },
        custom_event: {
          title: 'Modifier l\'événement ',
          date: 'Date : ',
          is_apt: 'Est-ce un rendez-vous ?',
          select: 'Sélectionnez la catégorie',
          select2: 'Sélectionnez le client ',
          is_contact: 'Contacter le client pour lui rappeler le rendez-vous ?',
          total: 'Quotidien',
          start: 'Début :',
          finish: 'Fin :',
          title2: 'Titre :',
          edit: 'Modifier un',
          edit_all: 'Modifier tous',
          notes: 'Notes :'
        },
        print_event: {
          title: 'Rendez-vous',
          il: 'Le',
          hour: 'À',
          where: 'Chez'
        },
      },
      Statistics: {
        stats: {
          title: 'Statistiques',
          incasso: 'Revenu',
          sms: 'Dépense SMS',
          best_cust: 'Meilleur Client',
          worst_cate: 'Pire Catégorie',
          best_cate: 'Meilleure Catégorie',
          inter: 'Sélectionner Intervalle :',
          type: 'Sélectionner le Type de Graphique :',
          dal: 'De :',
          al: 'À :',
          max: 'Maximum : ',
          min: 'Minimum : ',
          med: 'Moyenne : ',
          tot: 'Total : ',
          none_category: 'Aucune Catégorie',
          none_client: 'Aucun Client',
          isto: 'Histogramme',
          linea: 'Ligne',
          year: 'Année',
          month: 'Mois',
          week: 'Semaine',
          day: 'Jour',
          day_w: 'Total des Jours de la Semaine',
          lun: 'Lundi',
          mar: 'Mardi',
          mer: 'Mercredi',
          gio: 'Jeudi',
          ven: 'Vendredi',
          sab: 'Samedi',
          dom: 'Dimanche',
          int:'intervalle',
        },
      },
    },
  },


  getText: (path, attribute, textValues) => {
    try {
      let lang = ''
      if (textValues.texts.hasOwnProperty(textValues.activeLang)) {
        lang = textValues.activeLang
      } else {
        lang = textValues.defaultLang
      }
      //console.log(lang)
      let section = textValues.texts[lang]
      //console.log(section)
      path.forEach(property => {
        section = section[property]
      });
      let text = ''
      //console.log('Sezione:',text)
      attribute.forEach(atr => {
        text += `${section[atr]} `
      })
      //console.log('Testo:',text)
      return text.slice(0, -1)
    } catch {
      return 'error'
    }
  }
};

const TextContext = createContext(
  { set: undefined, get: undefined }
);

export default TextContext 
